import React from 'react';
import { submitReportDailyLog } from "../../pages/helper.js";
import ReactTable from "react-table";
import { translate } from 'react-internationalization';
import * as session from '../SessionValidator';
import SimpleReactValidator from 'simple-react-validator';
import { ToastContainer, toast } from 'react-toastify';
import { confirmAlert } from 'react-confirm-alert';
import RCSelect from '../select';
import * as enums from '../enums/supplier';
import { cnpj } from '../cpf-cnpj-validator';
import { cpf } from '../cpf-cnpj-validator';
import { cpf_cnpj_Mask } from '../mask';
import $ from 'jquery';

const moment = window.Moment;

export default class AddressSupplierComponent extends React.Component {
    constructor(props) {
        super(props);

        this.setValidators();
        this.token = session.getToken();
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleTypingEmail = this.handleTypingEmail.bind(this);
        this.saveAddress = this.saveAddress.bind(this);
        this.editAddress = this.editAddress.bind(this);
        this.deleteAddress = this.deleteAddress.bind(this);
        this.resetAddress = this.resetAddress.bind(this);
        this.handlechangeMask = this.handlechangeMask.bind(this)

        this.state = {


            currentAddress: {

                rowIndex: -1,
                address: {
                    id: 0,
                    name: '',
                    legalName: '',
                    document: '',
                    documentType: 0,
                    countryId: 403,
                    stateId: 0,
                    city: '',
                    district: '',
                    street: '',
                    number: '',
                    complement: '',
                    zipCode: '',
                    isMaster: true,
                    phoneNumber: '',
                    email: '',
                    stateRegistration: '',
                    stateName: '',
                    countryName: ''
                }
            },

            countries: null,
            addressStates: null,

            addressList: [],
            loading: false,

            reportDailyLog: {
                startDate: moment().format(),
                objectAfter: '',
                objectBefore: ''
            },
        };
    }

    async componentDidUpdate() {

        let _this = this;

        $('.js-supplier-address-change').each(function () { _this.setValue(this); });
        $('.js-phone-number').inputmask({ greedy: false, mask: '(99) 9999[9]-9999', showMaskOnHover: false });
    }

    async componentDidMount() {

        let _this = this;

        $('body').on('change', '.js-supplier-address-change', function (event) { _this.handleChange(event); });

        $('.js-phone-number').inputmask({ greedy: false, mask: '(99) 9999[9]-9999', showMaskOnHover: false });

        fetch(window.$CustomerServiceURL + '/api/Country/List',
            {
                method: 'GET', // *GET, POST, PUT, DELETE, etc.
                mode: 'cors', // no-cors, *cors, same-origin
                cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                credentials: 'same-origin', // include, *same-origin, omit
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                },
                redirect: 'follow', // manual, *follow, error
                referrer: 'no-referrer' // no-referrer, *client
            })
            .then(res => {

                if (res.status === 401) {
                    session.sessionExpired();
                    res = [];

                    return res;
                }

                if (res.status === 403) {
                    session.accessDenied();
                    res = [];

                    return res;
                }

                return res.json();

            })
            .then(res => {

                res.data = res.data.sort(function (a, b) { return (a.name < b.name) ? -1 : (a.name > b.name) ? 1 : 0; });

                this.setState({ countries: res.data });

                let countrySelected = this.state.countries.find(item => { return item.id === this.state.currentAddress.address.countryId; });

                if (countrySelected)
                    this.state.currentAddress.address.countryName = countrySelected.name;

                this.loadStates('addressStates', 'addressStatesLoading', 403);// 403 = Brasil

                this.forceUpdate();
            });

        if (this.props.supplierId) {
            fetch(window.$SupplierServiceURL + '/api/supplier/ListSupplierAddress/' + this.props.supplierId,
                {
                    method: 'GET', // *GET, POST, PUT, DELETE, etc.
                    mode: 'cors', // no-cors, *cors, same-origin
                    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                    credentials: 'same-origin', // include, *same-origin, omit
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    },
                    redirect: 'follow', // manual, *follow, error
                    referrer: 'no-referrer' // no-referrer, *client
                })
                .then(res => {

                    if (res.status === 401) {
                        session.sessionExpired();
                        res = [];

                        return res;
                    }

                    if (res.status === 403) {
                        session.accessDenied();
                        res = [];

                        return res;
                    }

                    return res.json();

                    if (res.status === 404) {
                        res = [];

                        return res;

                    }

                })
                .then(res => {

                    res.data = res.data.sort(function (a, b) { return (a.name < b.name) ? -1 : (a.name > b.name) ? 1 : 0; });

                    this.setState({ addressList: res.data });
                    this.forceUpdate();
                });
        } else {

            let currentAddress = {

                rowIndex: -1,
                address: {

                    name: '',
                    legalName: '',
                    document: '',
                    documentType: 0,
                    country: {},
                    state: {},
                    city: '',
                    district: '',
                    street: '',
                    number: '',
                    complement: '',
                    zipCode: '',
                    isMaster: true,
                    phoneNumber: '',
                    email: '',
                    stateRegistration: ''
                }
            };

            let addressList = [];

            this.setState({
                currentAddress: currentAddress,
                addressList: addressList
            });
            this.forceUpdate();
        }
    }


    async handleChange(event) {

        session.validateSession();

        let keys = event.target.name.split('.'), property = this.state;

        if (event.target.id === "cmbAddressCountry") {

            this.state.addressStates = null;

            if (event.target.value > 0) this.loadStates('addressStates', 'addressStatesLoading', event.target.value);

            let countrySelected = this.state.countries.find(item => { return item.id === event.target.value; });

            if (countrySelected)
                this.state.currentAddress.address.countryName = countrySelected.name;
        }

        if (event.target.id === "cmbAddressState") {

            let stateSelected = this.state.addressStates.find(item => { return item.id === event.target.value; });

            if (stateSelected)
                this.state.currentAddress.address.stateName = stateSelected.name;
        }

        keys.forEach(key => {

            if (property[key] !== null && typeof property[key] === 'object') {

                property = property[key];
                if (Array.isArray(property)) property = property[event.target.dataset.index];

            } else {

                let value;
                if (event.target.type === 'checkbox') { value = event.target.checked; }
                else { value = event.target.value; }

                property[key] = value;
            }
        });

        this.forceUpdate();

        this.setState(this.state);
    }

    handlechangeMask(e) {
        e.target.value = cpf_cnpj_Mask(e.target.value);
    }

    setValue(element) {

        let keys = element.name.split('.'), property = this.state;

        keys.forEach(key => {

            property = property[key];
            if (Array.isArray(property)) property = property[element.dataset.index];

        });

        $(element).val(property);
    }

    handleTypingEmail(e) {
        e.target.value = e.target.value.toLowerCase()
    }

    resetAddress() {

        this.state.currentAddress = {

            rowIndex: -1,
            address: {
                id: 0,
                name: '',
                legalName: '',
                document: '',
                documentType: 0,
                countryId: 403,
                stateId: null,
                city: '',
                district: '',
                street: '',
                number: '',
                complement: '',
                zipCode: '',
                isMaster: true,
                phoneNumber: '',
                email: '',
                stateRegistration: ''
            }
        };

        if (this.addressValidator !== undefined) {
            this.addressValidator.hideMessages();
        }

        this.setState(this.state);
    }

    saveAddress() {

        if (!this.addressValidator.allValid()) {

            this.addressValidator.showMessages();
            this.forceUpdate();
            return;
        }

        this.handleSubmit();
    }

    editAddress(rowIndex) {

        let reportDailyLog = this.state.reportDailyLog;

        this.state.currentAddress.address = JSON.parse(JSON.stringify(this.state.addressList[rowIndex]));
        this.state.currentAddress.rowIndex = rowIndex;

        if (this.state.addressList[rowIndex].countryId > 0) this.loadStates('addressStates', 'addressStatesLoading', this.state.addressList[rowIndex].countryId);

        reportDailyLog.objectBefore = JSON.stringify(this.state.currentAddress.address);

        this.setState(this.state);
        this.forceUpdate();
    }

    async loadStates(states, statesLoading, countryId) {

        this.state[statesLoading] = true;
        this.setState(this.state);

        fetch(window.$CustomerServiceURL + '/api/State/List?countryId=' + countryId,
            {
                method: 'GET', // *GET, POST, PUT, DELETE, etc.
                mode: 'cors', // no-cors, *cors, same-origin
                cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                credentials: 'same-origin', // include, *same-origin, omit
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                },
                redirect: 'follow', // manual, *follow, error
                referrer: 'no-referrer' // no-referrer, *client
            })
            .then(res => {

                if (res.status === 401) {
                    session.sessionExpired();
                    res = [];

                    return res;
                }

                if (res.status === 403) {
                    session.accessDenied();
                    res = [];

                    return res;
                }

                return res.json();

            })
            .then(res => {

                this.state[states] = res.data;
                this.state[statesLoading] = false;

                this.setState(this.state);

                this.forceUpdate();
            });
    }

    handleSubmit() {

        let reportDailyLog = this.state.reportDailyLog;

        this.setState({ loading: true });

        var method = this.state.currentAddress.address.id > 0 ? 'UpdateAddress' : 'AddAddress';

        this.state.currentAddress.address.supplierId = this.props.supplierId;

        var status = 0;

        fetch(window.$SupplierServiceURL + '/api/supplier/' + method,
            {
                method: 'POST', // *GET, POST, PUT, DELETE, etc.
                mode: 'cors', // no-cors, *cors, same-origin
                cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                credentials: 'same-origin', // include, *same-origin, omit
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                },
                body: JSON.stringify(this.state.currentAddress.address),
                redirect: 'follow', // manual, *follow, error
                referrer: 'no-referrer' // no-referrer, *client
            })
            .then(res => {
                status = res.status;

                if (res.status === 401) {
                    session.sessionExpired();
                    res = [];

                    return res;
                }

                if (res.status === 403) {
                    session.accessDenied();
                    res = [];

                    return res;
                }

                return res.json();

            })
            .then(res => {
                switch (status) {

                    case 200:
                        var address = JSON.parse(JSON.stringify(this.state.currentAddress.address));

                        reportDailyLog.action = 12; // 12 = updateSupplier
                        reportDailyLog.objectAfter = JSON.stringify(address);
                        submitReportDailyLog(reportDailyLog);

                        address.id = res.data.id;
                        
                        if (address.isMaster) {

                            //desabilita todos
                            for (var i = 0; i < this.state.addressList.length; i++) {

                                this.state.addressList[i].isMaster = false;
                            }
                        }

                        if (this.state.currentAddress.rowIndex < 0) {

                            this.state.addressList.push(address);

                        } else {

                            this.state.addressList[this.state.currentAddress.rowIndex] = address;
                        }

                        this.resetAddress();

                        this.setState({ loading: false });

                        this.forceUpdate();
                        break;

                    case 400:
                    case 409:
                        var messages = res.data;
                        messages.forEach(ex => toast.warn(ex.message));
                        break;

                    case 500:
                        toast.error('error');
                        break;
                }
            });
    }

    deleteAddress(rowIndex) {

        confirmAlert({

            buttons: [
                {
                    label: translate('forms.buttonYes'),
                    onClick: () => {

                        let address = JSON.parse(JSON.stringify(this.state.addressList[rowIndex]));

                        let addressId = address.id;

                        this.handleDeleteAddress(addressId, rowIndex);
                    }
                },
                {
                    label: translate('forms.buttonNo'),
                    onClick: () => { window.close(); }
                }
            ],
            message: translate('supplier.supplierContactDeleteTitle'),
            title: translate('supplier.supplierContactDeleteQuestion')
        });

    }

    handleDeleteAddress(addressId, rowIndex) {

        let reportDailyLog = this.state.reportDailyLog;
        var status = 0;

        this.setState({ loading: true });


        fetch(window.$SupplierServiceURL + '/api/Supplier/DeleteAddress/' + addressId,
            {
                method: 'GET', // *GET, POST, PUT, DELETE, etc.
                mode: 'cors', // no-cors, *cors, same-origin
                cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                credentials: 'same-origin', // include, *same-origin, omit
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                },
                redirect: 'follow', // manual, *follow, error
                referrer: 'no-referrer' // no-referrer, *client
            })
            .then(res => {
                status = res.status;
                this.setState({ loading: false });

                if (res.status === 401) {
                    session.sessionExpired();
                    res = [];

                    return res;
                }

                if (res.status === 403) {
                    session.accessDenied();
                    res = [];

                    return res;
                }

                return res.json();

            })
            .then(res => {
                switch (status) {

                    case 200:
                        let address = JSON.parse(JSON.stringify(this.state.addressList[rowIndex]));

                        var items = this.state.addressList;
                        items.splice(rowIndex, 1);
                        this.state.addressList = items;

                        reportDailyLog.action = 12; // 12 = updateSupplier
                        reportDailyLog.objectAfter = JSON.stringify(address);
                        submitReportDailyLog(reportDailyLog);

                        this.forceUpdate();

                        break;

                    case 400:
                    case 409:
                        var messages = res.data;
                        messages.forEach(ex => toast.warn(ex.message));
                        break;

                    case 500:
                        toast.error('error');
                        break;
                }
            });

    }

    setValidators() {

        this.validator = new SimpleReactValidator({

            typePerson: {

                rule: (value) => {

                    return ['', null, undefined].indexOf(value) < 0;
                }
            },
        });

        this.addressValidator = new SimpleReactValidator({

            state: {

                rule: value => {

                    return !this.state.currentAddress || this.state.currentAddress.length <= 0 || parseInt(value) > 0;
                }
            },

            documentType: {

                rule: (value) => {

                    return ['', null, undefined].indexOf(value) < 0;
                }
            },

            document: {

                rule: (value) => {

                    let documentType = this.state.currentAddress.address.documentType;

                    if (documentType == 0)//cnpj
                    {
                        return cnpj.isValid(value);
                    }
                    else if (documentType == 1) {//cpf
                        return cpf.isValid(value);
                    }
                    else {
                        return false;
                    }
                }
            },

            documentAdded: {

                rule: (value) => {

                    var item = this.state.addressList ? this.state.addressList.find(item => { return item.document.replace(".", "").replace(".", "").replace("-", "").replace("/", "") === value.replace(".", "").replace(".", "").replace("-", "").replace("/", ""); }) : null;

                    return !item || (item && this.state.currentAddress.rowIndex >= 0);
                }
            },

            email: {

                rule: function (val) {

                    if (val === '')
                        return true;

                    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(val.trim()))
                        return false;

                    return true;
                }
            }
        });
    }

    render() {
        return (
            <div>
                {
                    session.auth([{ type: "Supplier", value: "Save" }]) &&
                    <div>
                        <div>
                            <div className="m-b-40">
                                <small>{translate('supplier.supplierAddressTitleDescription')}</small>
                            </div>
                        </div>

                        <div>

                            <div className="row clearfix">
                                <div className="col-md-10">
                                    <div className="input-group">
                                        <label className="validationRequired" htmlFor="txtAddressName">{translate('supplier.supplierAddressName')}</label>

                                        <div className="form-line">
                                            <input id="txtAddressName" name="currentAddress.address.name" className="form-control js-supplier-address-change" placeholder={translate('supplier.supplierAddressNamePlaceHolder')} type="text" />
                                        </div>

                                        {this.addressValidator.message('currentAddress.address.name', this.state.currentAddress.address.name, 'required', false, { default: translate('supplier.supplierAddressNameRequired') })}
                                    </div>
                                </div>

                                <div className="col-md-2">
                                    <div className="m-t-30">
                                        <input id="chkIsMaster" name="currentAddress.address.isMaster" type="checkbox" checked={this.state.currentAddress.address.isMaster} onChange={this.handleChange} />
                                        <label htmlFor="chkIsMaster">{translate('supplier.supplierAddressIsMaster')}</label>
                                    </div>
                                </div>
                            </div>

                            <div className="row clearfix">

                                <div className="col-md-4">
                                    <div className="input-group">
                                        <label htmlFor="txtLegalName" className="validationRequired"> {translate('supplier.supplierLegalName')} </label>

                                        <div className="form-line">
                                            <input id="txtLegalName" name="currentAddress.address.legalName" className="form-control js-supplier-address-change" autoComplete="off" maxLength='100' placeholder={translate('supplier.supplierLegalNamePlaceHolder')} type="text" />
                                        </div>

                                        {this.addressValidator.message('currentAddress.address.legalName', this.state.currentAddress.address.legalName, 'required', false, { default: translate('supplier.supplierLegalNameRequired') })}
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="m-b-20">
                                        <label htmlFor="cmbDocumentType" className="validationRequired">
                                            {translate('supplier.supplierDocumentType')}
                                        </label>

                                        <RCSelect
                                            id="cmbDocumentType"
                                            name="currentAddress.address.documentType"
                                            hasEmptyOption={true}
                                            isInt={true}
                                            options={enums.getDocumentType()}
                                            optionValue="index"
                                            optionLabel="text"
                                            placeholder={translate('supplier.supplierDocumentTypePlaceHolder')}
                                            onChange={event => { this.handleChange(event); }}
                                            value={this.state.currentAddress.address.documentType}
                                        />

                                        {this.addressValidator.message('cmbDocumentType', this.state.currentAddress.address.documentType, 'required|documentType', false, { default: translate('supplier.supplierDocumentTypeRequired') })}
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="input-group">
                                        <label htmlFor="txtDocument" className="validationRequired"> {translate('supplier.supplierDocument')} </label>

                                        <div className="form-line">
                                            <input id="txtDocument" name="currentAddress.address.document" maxLength='19' onChange={this.handlechangeMask} className="form-control js-supplier-address-change" autoComplete="off" placeholder={translate('supplier.supplierDocumentPlaceHolder')} type="text" />
                                        </div>

                                        {this.addressValidator.message('currentAddress.address.document', this.state.currentAddress.address.document, 'required|document|documentAdded', false, { default: translate('supplier.supplierDocumentRequired'), document: this.state.currentAddress.address.documentType == 0 ? translate('supplier.supplierCNPJInvalid') : translate('supplier.supplierCPFInvalid'), documentAdded: translate('supplier.supplierDocumentAdded') })}
                                    </div>
                                </div>

                            </div>

                            <div className="row clearfix">
                                <div className="col-md-4">
                                    <div className="input-group">
                                        <label className="validationRequired" htmlFor="txtStreetName">{translate('supplier.supplierAddressStreet')}</label>

                                        <div className="form-line">
                                            <input id="txtStreetName" name="currentAddress.address.street" className="form-control js-supplier-address-change" placeholder={translate('supplier.supplierAddressStreetPlaceHolder')} type="text" />
                                        </div>

                                        {this.addressValidator.message('currentAddress.address.street', this.state.currentAddress.address.street, 'required', false, { default: translate('supplier.supplierAddressStreetRequired') })}
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="input-group">
                                        <label htmlFor="txtStreetNumber">{translate('supplier.supplierAddressNumber')}</label>

                                        <div className="form-line">
                                            <input id="txtStreetNumber" name="currentAddress.address.number" className="form-control js-supplier-address-change js-integer" placeholder={translate('supplier.supplierAddressNumberPlaceHolder')} type="text" />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="input-group">
                                        <label htmlFor="txtDistrict">{translate('supplier.supplierAddressDistrict')}</label>

                                        <div className="form-line">
                                            <input id="txtDistrict" name="currentAddress.address.district" className="form-control js-supplier-address-change" placeholder={translate('supplier.supplierAddressDistrictPlaceHolder')} type="text" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row clearfix">
                                <div className="col-md-4">
                                    <div className="input-group">
                                        <label className="validationRequired" htmlFor="txtZipCode">{translate('supplier.supplierAddressZipCode')}</label>

                                        <div className="form-line">
                                            <input id="txtZipCode" name="currentAddress.address.zipCode" className="form-control js-supplier-address-change js-zipcode" placeholder={translate('supplier.supplierAddressZipCodePlaceHolder')} type="text" />
                                        </div>

                                        {this.addressValidator.message('currentAddress.address.zipCode', this.state.currentAddress.address.zipCode, 'required', false, { default: translate('supplier.supplierAddressZipCodeRequired') })}
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="input-group">
                                        <label className="validationRequired" htmlFor="txtCity">{translate('supplier.supplierAddressCity')}</label>

                                        <div className="form-line">
                                            <input id="txtCity" name="currentAddress.address.city" className="form-control js-supplier-address-change" placeholder={translate('supplier.supplierAddressCityPlaceHolder')} type="text" />
                                        </div>

                                        {this.addressValidator.message('currentAddress.address.city', this.state.currentAddress.address.city, 'required', false, { default: translate('supplier.supplierAddressCityRequired') })}
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="input-group">
                                        <label htmlFor="txtComplement">{translate('supplier.supplierAddressComplement')}</label>

                                        <div className="form-line">
                                            <input id="txtComplement" name="currentAddress.address.complement" className="form-control js-supplier-address-change" placeholder={translate('supplier.supplierAddressComplementPlaceHolder')} type="text" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row clearfix">
                                <div className="col-md-6">
                                    <div className="m-b-20">
                                        <label className="validationRequired" htmlFor="cmbAddressCountry">{translate('supplier.supplierAddressCountry')}</label>

                                        <RCSelect
                                            id="cmbAddressCountry"
                                            name="currentAddress.address.countryId"
                                            hasEmptyOption={true}
                                            isInt={true}
                                            options={this.state.countries}
                                            optionValue="id"
                                            optionLabel="name"
                                            placeholder={translate('supplier.supplierAddressCountryPlaceHolder')}
                                            onChange={event => { this.handleChange(event); }}
                                            value={this.state.currentAddress.address.countryId}
                                        />

                                        {this.addressValidator.message('currentAddress.address.countryId', this.state.currentAddress.address.countryId, 'gt: 0', false, { default: translate('supplier.supplierAddressCountryRequired') })}
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="m-b-20">
                                        <label htmlFor="cmbAddressState" className={this.state.addressStates && this.state.addressStates.length > 0 ? 'validationRequired' : ''}>
                                            {translate('supplier.supplierAddressState')}
                                        </label>

                                        <div className="preloader pl-size-xs form-preloader" style={{ display: this.state.addressStatesLoading ? 'inline-block' : 'none' }}>
                                            <div className="spinner-layer">
                                                <div className="circle-clipper left">
                                                    <div className="circle"></div>
                                                </div>
                                            </div>
                                        </div>

                                        <RCSelect
                                            id="cmbAddressState"
                                            name="currentAddress.address.stateId"
                                            hasEmptyOption={true}
                                            isInt={true}
                                            options={this.state.addressStates != null ? this.state.addressStates : this.state.states}
                                            optionValue="id"
                                            optionLabel="displayName"
                                            placeholder={translate('supplier.supplierAddressStatePlaceHolder')}
                                            onChange={event => { this.handleChange(event); }}
                                            value={this.state.currentAddress.address.stateId}
                                        />

                                        {this.addressValidator.message('cmbAddressState', this.state.currentAddress.address.stateId, 'gt: 0|state', false, { default: translate('supplier.supplierAddressStateRequired') })}
                                    </div>
                                </div>
                            </div>

                            <div className="row clearfix">

                                <div className="col-md-3">
                                    <div className="input-group">
                                        <label className="validationRequired" htmlFor="txtAddressPhoneNumber">{translate('supplier.supplierContactPhoneNumber')}</label>

                                        <div className="form-line">
                                            <input id="txtAddressPhoneNumber" maxLength="15" className="form-control js-supplier-address-change js-phone-number" name="currentAddress.address.phoneNumber" placeholder={translate('supplier.supplierContactPhoneNumberPlaceHolder')} type="text" />
                                        </div>

                                        {this.addressValidator.message('currentAddress.address.phoneNumber', this.state.currentAddress.address.phoneNumber, 'required', false, { default: translate('supplier.supplierContactPhoneNumberRequired') })}
                                    </div>
                                </div>

                                <div className="col-md-5">
                                    <div className="input-group">
                                        <label htmlFor="txtAddressEmail">{translate('supplier.supplierEmail')}</label>

                                        <div className="form-line">
                                            <input id="txtAddressEmail" className="form-control js-supplier-address-change" name="currentAddress.address.email" placeholder={translate('supplier.supplierEmailPlaceHolder')} onKeyUp={this.handleTypingEmail} type="text" />
                                        </div>

                                        {this.addressValidator.message('currentAddress.address.email', this.state.currentAddress.address.email, 'email', false, { default: translate('supplier.supplierEmailInvalid') })}
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="input-group">
                                        <label htmlFor="txtStateRegistration"> {translate('supplier.supplierAddressStateRegistration')} </label>

                                        <div className="form-line">
                                            <input id="txtStateRegistration" name="currentAddress.address.stateRegistration" className="form-control js-supplier-address-change" autoComplete="off" placeholder={translate('supplier.supplierAddressStateRegistrationPlaceHolder')} type="text" />
                                        </div>

                                    </div>
                                </div>

                            </div>

                            <div className="row clearfix">
                                <div className="col-md-12">
                                    <button type="button" className="btn m-r-10" onClick={this.resetAddress} style={{ display: this.state.currentAddress.rowIndex >= 0 ? 'inline-block' : 'none' }}>
                                        <i className="material-icons">&#xe5c4;</i>
                                        <span>{translate('forms.buttonCancel')}</span>
                                    </button>

                                    <button type="button" className="btn btn-primary" onClick={this.saveAddress}>
                                        <i className="material-icons">&#xe145;</i>
                                        <span>{translate(this.state.currentAddress.rowIndex < 0 ? 'supplier.supplierAddressesAddNew' : 'supplier.supplierAddressesUpdate')}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                <ReactTable
                    data={this.state.addressList}
                    columns={[
                        {
                            columns: [
                                {
                                    Header: translate('supplier.supplierAddressName'),
                                    accessor: "name",
                                },
                                {
                                    Header: translate('supplier.supplierDocument'),
                                    accessor: "document",
                                },
                                {
                                    Header: translate('supplier.supplierAddressState'),
                                    accessor: "stateName",

                                },
                                {
                                    Header: translate('supplier.supplierAddressCity'),
                                    accessor: "city",

                                },
                                {
                                    Header: translate('supplier.supplierAddressDistrict'),
                                    accessor: "district",

                                },
                                {
                                    Header: translate('supplier.supplierAddressIsMaster'),
                                    Cell: row => {
                                        return <div className="align-center">

                                            {row.original.isMaster &&
                                                <i className="material-icons color-success">&#xe86c;</i>
                                            }
                                            {!row.original.isMaster &&
                                                <i className="material-icons color-danger">&#xe5c9;</i>
                                            }

                                        </div>
                                    },
                                    maxWidth: 100
                                },
                                session.auth([{ type: "Supplier", value: "Save" }]) &&
                                {
                                    Cell: row => (
                                        <div className="align-center">
                                            <button className="btn btn-danger btn-circle waves-effect waves-circle waves-float m-r-10" type="button" disabled={this.state.currentAddress.rowIndex >= 0} onClick={() => { this.deleteAddress(row.index) }}>
                                                <i className="material-icons">&#xe872;</i>
                                            </button>

                                            <button type="button" className="btn bg-deep-purple btn-circle waves-effect waves-circle waves-float m-r-10" disabled={this.state.currentAddress.rowIndex >= 0} onClick={() => { this.editAddress(row.index) }}>
                                                <i className="material-icons">&#xe3c9;</i>
                                            </button>
                                        </div>
                                    ),
                                    maxWidth: 150
                                }
                            ]
                        }
                    ]}
                    SubComponent={row => {
                        return <div className="m-l-30 m-r-30 m-t-30">
                            <div className="row">
                                <div className="col-md-3">
                                    <p>
                                        {translate('supplier.supplierAddressCountry')}:
                                        <b> {row.original.countryName}</b>
                                    </p>
                                </div>

                                <div className="col-md-4">
                                    <p>
                                        {translate('supplier.supplierLegalName')}:
                                        <b> {row.original.legalName}</b>
                                    </p>
                                </div>

                                <div className="col-md-5">
                                    <p>
                                        {translate('supplier.supplierAddressStreet')}:
                                        <b> {row.original.street}</b>
                                    </p>
                                </div>

                                <div className="col-md-3">
                                    <p>
                                        {translate('supplier.supplierAddressZipCode')}:
                                        <b> {row.original.zipCode}</b>
                                    </p>

                                </div>
                                <div className="col-md-4">
                                    <p>
                                        {translate('supplier.supplierAddressNumber')}:
                                        <b> {row.original.number}</b>
                                    </p>
                                </div>

                                <div className="col-md-5">
                                    <p>
                                        {translate('supplier.supplierAddressComplement')}:
                                        <b> {row.original.complement}</b>
                                    </p>
                                </div>

                                <div className="col-md-3">
                                    <p>
                                        {translate('supplier.supplierContactPhoneNumber')}:
                                        <b> {row.original.phoneNumber}</b>
                                    </p>
                                </div>

                                <div className="col-md-4">
                                    <p>
                                        {translate('supplier.supplierEmail')}:
                                        <b> {row.original.email}</b>
                                    </p>
                                </div>

                                <div className="col-md-5">
                                    <p>
                                        {translate('supplier.supplierAddressStateRegistration')}:
                                        <b> {row.original.stateRegistration}</b>
                                    </p>
                                </div>

                            </div>
                        </div>
                    }}
                    defaultPageSize={10}
                    className="-striped -highlight m-b-40"
                    previousText={translate('forms.previousText')}
                    nextText={translate('forms.nextText')}
                    noDataText={translate('forms.noDataText')}
                    pageText={translate('forms.pageText')}
                    ofText={translate('forms.ofText')}
                    rowsText={translate('forms.rowsText')}
                />
            </div>
        )
    }
}